import {
	calculateAggregateValuesKeywordData,
	calculcateTagLimitByWidthAndHeight,
	mergeWithTagLimit,
	sortKeywords
} from 'components/weblyzard/tagcloud/p-tagcloud.js';
import { groupByName } from 'utils/p-functions/general';

// sets can be an array with keywords or a dictionary with topics that have each an array with keywords
export default (sets, width, height) => {
	const limit = calculcateTagLimitByWidthAndHeight([width, height]);
	// mergeWithTagLimit expects array with keyword arrays
	const keywordsArray = Array.isArray(sets) ? [sets] : Object.values(sets).map(x =>
		x.keywords.map(keyword => Object.assign({ topic: { color: x.color } }, keyword))
	);
	const merged = mergeWithTagLimit(keywordsArray, limit);

	return sortKeywords(calculateAggregateValuesKeywordData(groupByName(merged)));
};
